<div class="form-field-date">

  <mat-form-field appearance="fill">
  <mat-label>{{label}}</mat-label>

  <input
    readonly
    matInput
    class="form-control"
    [disabled]="disabled"
    [id]="id"
    [placeholder]="placeholder"
    [type]="type"
    [matDatepicker]="dp"
    [formControl]="date"
    [min]="minDate"
    (click)="initPicker(dp)"
  />
  <mat-datepicker
    #dp
    startView="multi-year"
    (yearSelected)="chosenYearHandler($event)"
    (monthSelected)="chosenMonthHandler($event, dp)"
    panelClass="card-datepicker"
  >
  </mat-datepicker>
</mat-form-field>
</div>
<!-- <div class="form-field-date">
  <mat-form-field appearance="fill">
    <mat-label>{{label}}</mat-label>

    <input
        readonly
        class="form-control"
        [disabled]="disabled"
        [id]="id"
        [placeholder]="placeholder"
        [type]="type"
        [matDatepicker]="dp"
        [formControl]="date"
        [min]="minDate"
        (click)="initPicker(dp)"
    />
    <mat-datepicker
        #dp
        startView="multi-year"
        (yearSelected)="chosenYearHandler($event)"
        (monthSelected)="chosenMonthHandler($event, dp)"
        panelClass="example-month-picker"
      >
      </mat-datepicker>
  </mat-form-field>
</div> -->

<!-- <div class="form-field-date">
  <mat-form-field appearance="fill">
    <mat-label>{{label}}</mat-label>

    <input
      readonly
      [disabled]="disabled"
      [id]="id"
      [placeholder]="placeholder"
      [type]="type"
      [matDatepicker]="dp"
      [formControl]="date"
      [min]="minDate"
      (click)="initPicker(dp)"
      />
    <mat-datepicker
        #dp
        startView="multi-year"
        (yearSelected)="chosenYearHandler($event)"
        (monthSelected)="chosenMonthHandler($event, dp)"
        panelClass="example-month-picker"
      >
      </mat-datepicker>
  </mat-form-field>
</div> -->
